export default __webpack_public_path__ + "static/media/mob-menu-5.60ab03d6.png";